<template>
    <div class="card-box">
        <div class="card-title">
            <span class="card-title-text">{{ card.name || '未命名卡片' }}</span>
            <el-icon class="card-zoom" title="查看详情" @click="dialogVisible = true"><Search /></el-icon>
        </div>
        <div class="card-body">
            <div v-if="rows && rows.length" class="text-list">
                <div class="text-row" v-for="(row, idx) in rows" :key="idx">
                    <span class="text-icon">{{ row.icon }}</span>
                    <span class="text-key">{{ row.key }}</span>
                    <span class="text-val">{{ row.val }}</span>
                </div>
            </div>
            <div v-else class="card-placeholder">暂无数据</div>
        </div>

        <el-dialog v-model="dialogVisible" :title="card.name || '未命名卡片'" width="min(600px, 92vw)" :close-on-click-modal="false">
            <div v-if="rows && rows.length" class="dialog-list">
                <div class="text-row" v-for="(row, idx) in rows" :key="idx">
                    <span class="text-icon">{{ row.icon }}</span>
                    <span class="text-key">{{ row.key }}</span>
                    <span class="text-val">{{ row.val }}</span>
                </div>
            </div>
            <el-empty v-else description="暂无数据" />
        </el-dialog>
    </div>
</template>

<script>
import { Search } from '@element-plus/icons';
import request from '@/utils/request';

export default {
    name: 'CardText',
    components: { Search },
    props: {
        card: { type: Object, required: true },
        viewId: { type: String, default: '' },
        sectionIndex: { type: Number, default: -1 },
        cardIndex: { type: Number, default: -1 }
    },
    data() {
        return {
            rows: [],
            dialogVisible: false
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            if (!this.viewId || this.sectionIndex < 0 || this.cardIndex < 0) {
                return;
            }
            return request({
                url: '/dataview/getCardData',
                method: 'post',
                data: {
                    id: this.viewId,
                    sectionIndex: this.sectionIndex,
                    cardIndex: this.cardIndex
                }
            }).then(res => {
                if (res.code === 0) {
                    this.rows = res.meta.data || [];
                }
            });
        }
    }
};
</script>

<style scoped>
.card-box {
    border: 1px solid #e4e7ed;
    border-radius: 8px;
    background: #fff;
    overflow: hidden;
}
.card-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    font-size: 14px;
    font-weight: bold;
    border-bottom: 1px solid #f0f2f5;
    background: #fafafa;
    color: #303133;
}
.card-title-text {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.card-zoom {
    cursor: pointer;
    color: #909399;
    font-size: 16px;
    flex-shrink: 0;
}
.card-zoom:hover {
    color: #409eff;
}
.card-body {
    height: 200px;
    padding: 14px;
}
.text-list {
    height: 100%;
    overflow: auto;
}
.text-row {
    display: flex;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px solid #f0f2f5;
}
.text-row:last-child {
    border-bottom: none;
}
.text-icon {
    width: 28px;
    font-size: 16px;
    text-align: center;
    flex-shrink: 0;
}
.text-key {
    flex: 1;
    color: #606266;
    font-size: 13px;
    padding: 0 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.text-val {
    font-weight: bold;
    color: #303133;
    font-size: 14px;
    flex-shrink: 0;
}
.card-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #909399;
    font-size: 13px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
}
.dialog-list {
    max-height: 60vh;
    overflow: auto;
}
</style>
